import ReportLink from "./report-link";

const Model = ReportLink.extend({
  namedAttributes: {
    // drilldown modal layout type can be either:
    // "tabbed" (horizontal) or "stacked" (vertical)
    layout: String,
    returnRoute: String,
    returnRouteRefresh: Boolean,
  },
  defaults: {
    layout: "tabbed",
    returnRoute: null,
    returnRouteRefresh: false,
  },
});

export { Model as default };
